import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ml-table-header',
  template: `
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="mat-title"
      *ngIf="title"
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon *ngIf="titleIcon" svgIcon="{{ titleIcon }}"></mat-icon>
        <div class="mat-title no-margin">
          {{ title | translate | titlecase }}
        </div>

        <button
          [disabled]="disabledAdd"
          mat-icon-button
          *ngIf="settings"
          (click)="onClickSettings()"
        >
          <mat-icon svgIcon="settings"></mat-icon>
        </button>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <ng-content></ng-content>
        <ml-add-button
          [disabled]="disabledAdd"
          *ngIf="canAdd"
          (add)="add.emit()"
        ></ml-add-button>
      </div>
    </div>
  `,
  styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() titleIcon: string;
  @Input() canAdd = true;
  @Input() settings: boolean;
  @Input() disabledAdd: boolean;

  @Output() add = new EventEmitter();
  @Output() clickSettings = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onClickSettings() {
    this.clickSettings.emit();
  }
}
